



























































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { safetyAndEnvironmentAssessmentServer } from '@/api/installServer';
import ViewInnerPages from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/viewInnerPages.vue';

@Component({
  components: { ViewInnerPages, CollapseTransition, PagingUnit },
  mixins: [TableStripe],
})
export default class AssessmentPageComponent extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  private titleContent: any = '';
  private editRoleFlag: any = 1; // 控制显示 考核 页面
  private rowView: any = {}; // 控制显示 编辑 页面
  // 表单数据
  formData: any = {};

  private dataList: any = [];

  formRules: any = {
    suggestion: [{ required: true, trigger: 'blur', message: '请填写考勤组意见' }], // 任务名称
    // assessPunish: [{ required: true, trigger: 'blur', message: '请填写考核奖惩说明' }], // 任务名称
  };
  activeName: any = '';
  chooseTabId: any = '';
  assessRewardPunishment: any = '';

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    this.activeName = '';
    this.chooseTabId = '';
    this.titleContent = this.row.assessContent; // 标题
    this.formData = this.row;
    // 获取分页数据
    this.getPageData();
  }
  viewManagement(data: any) {
    this.rowView = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入编辑页面
  }

  private handleMenuEditResponse() {
    this.editRoleFlag = 1;
    this.getPageData();
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer
      .getAdjusttList(this.row)
      .then((res: any) => {
        // console.log(res);
        this.formData.suggestion = res.data.suggestion;
        this.dataList = res.data.vo;
        this.activeName = this.dataList[0].id;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  handleClick(tab: any, event: any) {
    this.chooseTabId = tab.name;
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.formData = {};
    this.$emit('on-response');
  }

  /**
   * @desc 点击保存按钮
   */
  save() {
    // const formComponent: any = this.$refs.form;
    // formComponent.validate((valid: any) => {
    //   if (!valid) {
    //     return;
    //   }
    this.addFunctionData();
    // });
  }

  // 审核
  examine() {
    safetyAndEnvironmentAssessmentServer
      .addAuditAssessReportData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('审核成功');
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('审核失败,请稍后重试!');
      });
  }

  /**
   * 【接口】新增功能
   */
  private async addFunctionData() {
    const obj: any = this.dataList.find((obj: any) => {
      return obj.id === this.chooseTabId ? this.chooseTabId : this.activeName;
    });
    this.assessRewardPunishment = obj.assessRewardPunishment;

    safetyAndEnvironmentAssessmentServer
      .addSavePunishmentsData({ id: this.chooseTabId ? this.chooseTabId : this.activeName, assessRewardPunishment: this.assessRewardPunishment })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          this.close(); // 返回到父级页面
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('保存失败,请稍后重试!');
      });
  }
}
